module.exports = __webpack_public_path__ + "img/vimc diamond.6a647bbf.png";